import {
    Component,
    ElementRef,
    HostListener,
    Input,
    OnInit,
    ViewChild
} from '@angular/core';

@Component({
    selector: 'floating-subtitle',
    templateUrl: './floating-subtitle.component.html',
    styleUrls: ['./floating-subtitle.component.scss']
})
export class FloatingSubtitleComponent implements OnInit {
    @Input() text: string;
    @Input() position: string;
    @ViewChild('fsComponent', { static: true }) fsComponent: ElementRef;
    @ViewChild('fsWrapper', { static: true }) fsWrapper: ElementRef;
    @ViewChild('fsSpan', { static: true }) fsSpan: ElementRef;
    private readonly ANIMATION_DELAY = 2000; // milliseconds
    private condition: boolean | null = null;
    private id: number | null = null;
    private readonly LEFT_TRANSLATION: number = 0.3; // 0.3 * 60 frames = 18 pixels per second
    private readonly PADDING_RIGHT: number = 1;
    private readonly RIGHT_TRANSLATION = 0.5;
    private running: boolean = false;
    private shouldAnimate: boolean = false;
    private toRight: boolean = false;
    private translation: number = 0;

    ngOnInit() {
        setTimeout(() => {
            this.updateAnimation();
        }, 100);
    }

    @HostListener('window:resize', [])
    onResize() {
        setTimeout(() => {
            this.updateAnimation();
        }, 100);
    }

    private updateAnimation(): void {
        this.checkWidths();
        if (this.shouldAnimate && !this.running) {
            this.addAnimation();
        } else if (!this.shouldAnimate && this.running) {
            this.removeAnimation();
        }
    }

    private checkWidths(): void {
        this.shouldAnimate = this.compareWidths();
    }

    private compareWidths(): boolean {
        return this.fsSpan.nativeElement.offsetWidth - 1 > this.fsWrapper.nativeElement.clientWidth + 1;
    }

    private addAnimation(): void {
        this.fsSpan.nativeElement.classList.add('floating-subtitle');
        if(this.position === 'right') this.fsComponent.nativeElement.classList.remove('tile__subtitle-row--right');
        if(this.position === 'center') this.fsComponent.nativeElement.classList.remove('tile__subtitle-row--center');
        this.fsComponent.nativeElement.classList.add('tile__subtitle-row--left');
        this.running = true;
        this.id = window.requestAnimationFrame(this.animation.bind(this));
    }

    removeAnimation(): void {
        this.fsSpan.nativeElement.classList.remove('floating-subtitle');
        window.cancelAnimationFrame(this.id);
        if(this.position === 'right') this.fsComponent.nativeElement.classList.add('tile__subtitle-row--right');
        if(this.position === 'center') this.fsComponent.nativeElement.classList.add('tile__subtitle-row--center');
        this.fsComponent.nativeElement.classList.remove('tile__subtitle-row--left');
        this.running = false;
        this.shouldAnimate = false;
        this.translation = 0;
        this.toRight = false;
        this.condition = null;
        this.fsSpan.nativeElement.style.transform = 'unset';
    }
    
    private animation(): void {
        this.translation +=
            (this.toRight ? this.RIGHT_TRANSLATION : this.LEFT_TRANSLATION) * (this.toRight ? 1 : -1);
        this.fsSpan.nativeElement.style.transform = 'translateX(' + this.translation + 'px)';
        if (!this.toRight) {
            this.condition = this.translation * (-1) > this.fsSpan.nativeElement.offsetWidth 
                - this.fsWrapper.nativeElement.clientWidth + this.PADDING_RIGHT
        } else {
            this.condition = this.translation > 0
        }
        if(this.condition && this.shouldAnimate) {
            window.cancelAnimationFrame(this.id);
            setTimeout(() => {
                this.toRight = !this.toRight;
                this.id = window.requestAnimationFrame(this.animation.bind(this));
            },this.ANIMATION_DELAY);
        } else {
            this.id = this.running ? window.requestAnimationFrame(this.animation.bind(this)) : null;
        }
    }
}
